export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '2.7.2',
};
//# sourceMappingURL=buildEnv.js.map